import fetch from './fetch'

export default {
  getOrganizations (payload) {
    let request = fetch({
      url: `/organization`,
      method: 'get',
      data: {},
      payload
    })
    return request.call()
  },
  getOrganization (id) {
    let request = fetch({
      url: `/organization/` + id,
      method: 'get',
      data: {}
    })
    return request.call()
  },
  getOrganizationLocations (payload) {
    // const organizationId = payload.organization
    // delete payload.organization

    let request = fetch({
      url: `/view/location/`,
      method: 'get',
      data: {},
      payload
    })

    return request.call()
  },

  getOrganizationPrograms (payload) {
    // const organizationId = payload.organization
    // delete payload.organization

    let request = fetch({
      url: `/view/program/`,
      method: 'get',
      data: {},
      payload
    })

    return request.call()
  },

  getOrgMemberships (payload) {
    let request = fetch({
      url: `/usermember`,
      method: 'get',
      data: {},
      payload
    })
    return request.call()
  },

  createOrganization (payload) {
    console.log('Payload Create Org >>>', payload)
    let request = fetch({
      url: `/organization/`,
      method: 'post',
      data: payload
    })
    return request.call()
  },

  updateOrganization (payload) {
    const { id, data } = payload
    let request = fetch({
      url: `/organization/` + id,
      method: 'patch',
      data: data
    })
    return request.call()
  },

  findByName (payload) {
    let request = fetch({
      url: `/organization/findByName?orgName=` + payload,
      method: 'get'
    })
    return request.call()
  },

  findGroupMemberships (payload) {
    let request = fetch({
      url: `/organization/findGroupMemberships`,
      method: 'get',
      data: {},
      payload
    })
    return request.call()
  },

  getProgramsByOrg (payload) {
    let request = fetch({
      url: `/view/orgprograms/`,
      method: 'get',
      data: {},
      payload
    })

    return request.call()
  },

  getLocationsByOrg (payload) {
    let request = fetch({
      url: `/view/orglocations/`,
      method: 'get',
      data: {},
      payload
    })
    return request.call()
  }
}



// WEBPACK FOOTER //
// ./src/api/organization.js